<template>
  <div class="pricing-card" :class="{'pricing-card--selected': isSelected}">
    <div v-show="isSelected && !isSubscriptionCancel" class="check-mark">
       <v-icon large class="ml-3">star</v-icon>
    </div>
    <div class="pricing-card__header">
      <v-icon v-if="name === 'Digital Risk Severity'" color="white" large>mdi-align-vertical-bottom</v-icon>
      <v-icon v-else color="white" large>mdi-apps</v-icon>
    </div>
    <div class="px-5 pricing-card__message">
      <div>{{message}}</div>
    </div>
    <div class="pricing-card__heading">
      <div>{{name}}</div>
      <ul>
        <li
          v-for="(item, index) in list"
          :key="item"
        >
          <div class="oval"></div>
          <div class="d-flex flex-row align-center">
            {{ item }}
            <span class="ml-1" v-if="(name === 'Digital Asset Discovery' && index == 0)"><v-icon color="white">mdi-plus</v-icon></span>
          </div>
        </li>
      </ul>
    </div>
    <div class="pricing-card__body">
      <div class="text-center footer-message" @click="showUpgradeDialog = true">
        {{ !isSubscriptionCancel ? footer : 'Buy Now'}}
      </div>
    </div>
    <upgrade-dialog
     v-if="showUpgradeDialog"
     :show="showUpgradeDialog"
     @closeDialog="closeUpgradeDialog"
     :plan="plan"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PaymentForm from './PaymentForm'
import UpgradeDialog from './UpgradeDialog.vue'
export default {
  name: 'Pricing',
  components: {
    PaymentForm,
    UpgradeDialog
  },
  props: {
    name: {
      type: String,
      default: null
    },
    price: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: null
    },
    message: {
      type: String,
      default: ''
    },
    plan: {
      type: String,
      default: ''
    },
    footer: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showUpgradeDialog: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState({
      paymentInformation: state => state.billingServices.paymentInformation
    }),
    getPlan () {
      if (this.paymentInformation && this.paymentInformation.subscription_plan) {
        return this.paymentInformation.subscription_plan.includes('cloud_plus') ? 'Cloud+' : 'Cloud'
      } else return ''
    },
    isSubscriptionCancel () {
      return this.paymentInformation && this.paymentInformation.is_canceled
    },
    isSelected () {
      return this.plan === this.getPlan
    }
  },
  methods: {
    closeUpgradeDialog () {
      this.showUpgradeDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .parent {
    width: 300px;
  }
  .pricing-card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1  );
    position: relative;
    background: #212338;
    height: 630px;
    min-width: 410px;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 25px;
    font-family: "gt_america_extended";
    padding: 70px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &__header {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 22px;
      color: #fff;
      padding-bottom: 30px;
    }
    &__message {
      font-size: 18px;
      color: #fff;
      text-align: center;
      font-weight: 600;
      padding-bottom: 30px;
    }
    &__heading {
      font-size: 28px;
      color: #fff;
      text-align: center;
      font-weight: 600;
      padding-bottom: 40px;
      white-space: nowrap;
      .oval{
        height: 4px;
        width: 4px;
        background-color: #3ACA56;
        margin-right: 10px;
      }
    }
    &__body {
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: auto;
      color: #ffffff;
      .footer-message {
        position: absolute;
        bottom: 20px;
      }
    }
    .price {
      margin-top: 10px;
      font-size: 22px;
      font-weight: bold;
      font-weight: 500;
      text-align: center;
      color: #fff
    }
    ul {
      display: flex;
      flex-direction: column;
      list-style-type: none;
      padding: 45px 0px 0px 0px !important;
      align-self: flex-start;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        color: #FFFFFF;
        font-family: "gt_america_extended";
        font-size: 14px;
        letter-spacing: 0;
        line-height: 24px;
        font-weight: 400;
      }
    }
    .check-mark {
      position: absolute;
      top: -18px;
      right: -51px;
      border-radius: 25px;
      background: linear-gradient(170.47deg, $primary-color 2.61%, $secondary-color 88.02%);;
      width: 165px;
      height: 92px;
      transform: rotate(45deg);
      text-align: center;
      .v-icon {
        font-size: 23px;
        color: #fff;
        margin-top: 35px;
        margin-left: 35px;
        transform: rotate(-45deg) translate(-5px, -2px);
      }
    }
  }
</style>
